import {Component} from '@angular/core';
import {Register} from '../../shared';
import {FeatureService} from '../../../feature/shared';


@Register({
  name: 'featureDetails',
  title: 'igo.featureDetails',
  icon: 'description'
})
@Component({
  selector: 'igo-feature-detail-tool',
  template: require('./feature-detail-tool.component.html'),
  styles: [require('./feature-detail-tool.component.styl')],
})
export class FeatureDetailToolComponent {
  constructor(public featureService: FeatureService) { }


}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/feature-detail-tool/feature-detail-tool.component.ts